module.exports = "/assets/data/8fa642a5fbf93b5e3509ddc4febca032-MK15.data.json";